const Textarea = {
	defaultProps: {
		variant: "flushed"
	}
};

export default Textarea;
